import * as React from "react";

function SvgKubit(props, ref) {
  return (
    <svg
      id="Kubit_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 370 370"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>
        {".Kubit_svg__st0{fill-rule:evenodd;clip-rule:evenodd;fill:#0076ea}"}
      </style>
      <g id="Kubit_svg__Logo-White">
        <path
          id="Kubit_svg__Rectangle"
          className="Kubit_svg__st0"
          d="M0 0h110v110H0z"
        />
        <path
          id="Kubit_svg__Rectangle-Copy"
          className="Kubit_svg__st0"
          d="M130 0h110v110H130z"
        />
        <path
          id="Kubit_svg__Rectangle_00000129896472101807962220000003977322688590390185_"
          className="Kubit_svg__st0"
          d="M0 130h110v110H0z"
        />
        <path
          id="Kubit_svg__Rectangle-Copy_00000152951574793532012650000017213265337904228504_"
          className="Kubit_svg__st0"
          d="M130 130h110v110H130z"
        />
        <path
          id="Kubit_svg__Rectangle-Copy-2"
          className="Kubit_svg__st0"
          d="M260 130h110v110H260z"
        />
        <path
          id="Kubit_svg__Rectangle-Copy_00000154398913064323963280000006688045844460235402_"
          className="Kubit_svg__st0"
          d="M130 260h110v110H130z"
        />
        <path
          id="Kubit_svg__Rectangle-Copy-2_00000028294578263252032780000013671543065078926012_"
          className="Kubit_svg__st0"
          d="M260 260h110v110H260z"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgKubit);
